/** @format */

import React, { Suspense } from "react";
import type { VisualEditorProps } from "./VisualEditor";
import { useTranslation } from "react-i18next";

const VisualEditor = React.lazy(() => import("./VisualEditor"));

const LazyVisualEditor: React.FC<VisualEditorProps> = (props) => {
  const { t: _ } = useTranslation();
  return (
    <Suspense fallback={<>{_("Loading")}...</>}>
      <VisualEditor {...props} />
    </Suspense>
  );
};

export default LazyVisualEditor;
